import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IPVKDataTableRowFormMeta {
  type: FormInputMeta,
  index: FormInputMeta,
  keyA: FormInputMeta,
  keyB: FormInputMeta,
  notes: FormInputMeta,
  usage: FormInputMeta,
  pvk1: FormInputMeta,
  inUse: FormInputMeta,
  //
  schema: any,
}

const PVKDataTableRowFormMeta = {} as IPVKDataTableRowFormMeta;

PVKDataTableRowFormMeta.type = {
  name: 'type',
  type: 'text',
  label: 'Type',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
PVKDataTableRowFormMeta.index = {
  name: 'index',
  type: 'text',
  label: 'Index',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
PVKDataTableRowFormMeta.keyA = {
  name: 'keyA',
  type: 'text',
  label: 'Clé value A',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
PVKDataTableRowFormMeta.keyB = {
  name: 'keyB',
  type: 'text',
  label: 'Clé value B',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
PVKDataTableRowFormMeta.notes = {
  name: 'notes',
  type: 'text',
  label: 'Notes',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
PVKDataTableRowFormMeta.usage = {
  name: 'usage',
  type: 'text',
  label: 'Usage',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
PVKDataTableRowFormMeta.pvk1 = {
  name: 'pvk1',
  type: 'text',
  label: 'Pvk1',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
PVKDataTableRowFormMeta.inUse = {
  name: 'inUse',
  type: 'checkbox',
  label: 'En usage',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};

PVKDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(PVKDataTableRowFormMeta));

export default PVKDataTableRowFormMeta;
